export default "__VITE_ASSET__kxlVGXXN__"